<template>
    <ValidationObserver ref="observer" tag="form" @submit.prevent="onSubmit">
        <div class="tw:space-y-6">
            <BaseInputNumber
                v-model="form.tecnica"
                label="Valoración Técnica"
                name="Val.Técnica"
                :min="0"
                :max="10"
                :step="1"
                rules="required|numeric|max_value:10|min_value:0"
            />
    
            <BaseInputNumber
                v-model="form.tactica"
                label="Valoración Táctica"
                name="Val.Táctica"
                :min="0"
                :max="10"
                :step="1"
                rules="required|numeric|max_value:10|min_value:0"
            />
    
            <BaseInputNumber
                v-model="form.fisica"
                label="Capacidad Física"
                name="Cap.Física"
                :min="0"
                :max="10"
                :step="1"
                rules="required|numeric|max_value:10|min_value:0"
            />
    
            <BaseInputNumber
                v-model="form.psicologica"
                label="Psicológica"
                name="Psicológica"
                :min="0"
                :max="10"
                :step="1"
                rules="required|numeric|max_value:10|min_value:0"
            />
    
            <BaseInputNumber
                v-model="form.personalidad"
                label="Personalidad"
                name="Personalidad"
                :min="0"
                :max="10"
                :step="1"
                rules="required|numeric|max_value:10|min_value:0"
            />
        </div>

        <div class="tw:flex tw:justify-between tw:gap-2 tw:mt-4">
            <Button
                variant="ghost"
                :disabled="loading"
                @click="$emit('cancel')"
            >
                Cancelar
            </Button>
            <Button
                type="submit"
                :loading="loading"
            >
                Guardar
            </Button>
        </div>
    </ValidationObserver>
</template>

<script setup>
    import { ref } from 'vue'
    import BaseInputNumber from '@/modules/admin/ui/BaseInputNumber.vue'
    import Button from '@/modules/admin/ui/Button.vue'
    import { useValoracionForm } from '@/composables/admin/bases/useValoracionForm'

    const props = defineProps({
        base_id: {
            type: [String, Number],
            required: true
        },
        valoracion: {
            type: Object,
            default: null
        }
    })

    const emit = defineEmits(['edit', 'cancel'])

    const observer = ref(null)

    const { form, loading, submit } = useValoracionForm({
        base_id: props.base_id,
        valoracion: props.valoracion
    })

    const onSubmit = async() => {
        const isValid = await observer.value?.validate()
        const success = await submit(isValid)
        if (success) {
            emit('edit')
        }
    }
</script>
